var exports = {
  "kx": "SetupBrandingPreview.module__hotspot___dmlwRV",
  "mr": "SetupBrandingPreview.module__highlighted___dmlwRV",
  "VH": "SetupBrandingPreview.module__preview___dmlwRV",
  "xd": "SetupBrandingPreview.module__tabsScroller___dmlwRV",
  "vR": "SetupBrandingPreview.module__tabs___dmlwRV",
  "dw": "SetupBrandingPreview.module__stage___dmlwRV",
  "JH": "SetupBrandingPreview.module__scene___dmlwRV",
  "pG": "SetupBrandingPreview.module__caption___dmlwRV",
  "zr": "SetupBrandingPreview.module__computerFrame___dmlwRV",
  "Z": "SetupBrandingPreview.module__browserChrome___dmlwRV",
  "nq": "SetupBrandingPreview.module__browserTabs___dmlwRV",
  "Q0": "SetupBrandingPreview.module__browserTab___dmlwRV",
  "Dm": "SetupBrandingPreview.module__favicon___dmlwRV",
  "Ul": "SetupBrandingPreview.module__browserTabTitle___dmlwRV",
  "aH": "SetupBrandingPreview.module__browserTabClose___dmlwRV",
  "Ok": "SetupBrandingPreview.module__addressBar___dmlwRV",
  "AI": "SetupBrandingPreview.module__addressIcon___dmlwRV",
  "jq": "SetupBrandingPreview.module__computerPage___dmlwRV",
  "k": "SetupBrandingPreview.module__pageBackground___dmlwRV",
  "oP": "SetupBrandingPreview.module__backdropImage___dmlwRV",
  "vo": "SetupBrandingPreview.module__backdropScrim___dmlwRV",
  "J4": "SetupBrandingPreview.module__backdropScrimPhone___dmlwRV",
  "Nr": "SetupBrandingPreview.module__card___dmlwRV",
  "$Z": "SetupBrandingPreview.module__cardSplit___dmlwRV",
  "cX": "SetupBrandingPreview.module__cardBrand___dmlwRV",
  "N_": "SetupBrandingPreview.module__cardLogoBox___dmlwRV",
  "kP": "SetupBrandingPreview.module__cardLogo___dmlwRV",
  "vg": "SetupBrandingPreview.module__cardWordmarkBox___dmlwRV",
  "kK": "SetupBrandingPreview.module__cardWordmark___dmlwRV",
  "Kv": "SetupBrandingPreview.module__phoneWordmark___dmlwRV",
  "V7": "SetupBrandingPreview.module__titlebarWordmark___dmlwRV",
  "ly": "SetupBrandingPreview.module__cardHost___dmlwRV",
  "VG": "SetupBrandingPreview.module__cardForm___dmlwRV",
  "yu": "SetupBrandingPreview.module__formSkeleton___dmlwRV",
  "Iz": "SetupBrandingPreview.module__skeletonTitle___dmlwRV",
  "Ql": "SetupBrandingPreview.module__skeletonLine___dmlwRV",
  "ES": "SetupBrandingPreview.module__skeletonInput___dmlwRV",
  "G3": "SetupBrandingPreview.module__skeletonButton___dmlwRV",
  "DV": "SetupBrandingPreview.module__skeletonButtonText___dmlwRV",
  "cp": "SetupBrandingPreview.module__phoneFrame___dmlwRV",
  "k0": "SetupBrandingPreview.module__phoneToolbar___dmlwRV",
  "Hj": "SetupBrandingPreview.module__phoneAddress___dmlwRV",
  "Un": "SetupBrandingPreview.module__phonePage___dmlwRV",
  "qC": "SetupBrandingPreview.module__phoneContent___dmlwRV",
  "$1": "SetupBrandingPreview.module__phoneIdentity___dmlwRV",
  "JC": "SetupBrandingPreview.module__phoneLogoBox___dmlwRV",
  "qO": "SetupBrandingPreview.module__phoneLogo___dmlwRV",
  "bm": "SetupBrandingPreview.module__phoneWordmarkBox___dmlwRV",
  "x_": "SetupBrandingPreview.module__phoneHost___dmlwRV",
  "tG": "SetupBrandingPreview.module__desktopScene___dmlwRV",
  "KF": "SetupBrandingPreview.module__windows___dmlwRV",
  "Mf": "SetupBrandingPreview.module__titlebarLabel___dmlwRV",
  "sy": "SetupBrandingPreview.module__platformTabs___dmlwRV",
  "_B": "SetupBrandingPreview.module__titlebarFigure___dmlwRV",
  "x": "SetupBrandingPreview.module__window___dmlwRV",
  "fZ": "SetupBrandingPreview.module__windowDark___dmlwRV",
  "bU": "SetupBrandingPreview.module__windowLight___dmlwRV",
  "uL": "SetupBrandingPreview.module__titlebar___dmlwRV",
  "pd": "SetupBrandingPreview.module__titlebarBrand___dmlwRV",
  "XC": "SetupBrandingPreview.module__titlebarMacos___dmlwRV",
  "MY": "SetupBrandingPreview.module__titlebarSpacer___dmlwRV",
  "TM": "SetupBrandingPreview.module__trafficLights___dmlwRV",
  "vu": "SetupBrandingPreview.module__windowControls___dmlwRV",
  "JM": "SetupBrandingPreview.module__windowBody___dmlwRV",
  "nP": "SetupBrandingPreview.module__windowRail___dmlwRV",
  "$S": "SetupBrandingPreview.module__windowSidebar___dmlwRV",
  "K6": "SetupBrandingPreview.module__windowMain___dmlwRV",
  "V9": "SetupBrandingPreview.module__windowLine___dmlwRV",
  "Xg": "SetupBrandingPreview.module__windowLineShort___dmlwRV",
  "Ez": "SetupBrandingPreview.module__instanceStage___dmlwRV",
  "y7": "SetupBrandingPreview.module__instanceRow___dmlwRV",
  "Ub": "SetupBrandingPreview.module__instanceRowOther___dmlwRV",
  "x$": "SetupBrandingPreview.module__instanceMark___dmlwRV",
  "Dq": "SetupBrandingPreview.module__instanceMeta___dmlwRV",
  "zl": "SetupBrandingPreview.module__instanceName___dmlwRV",
  "Qh": "SetupBrandingPreview.module__instanceHost___dmlwRV",
  "UC": "SetupBrandingPreview.module__instanceNameSkeleton___dmlwRV",
  "ji": "SetupBrandingPreview.module__instanceHostSkeleton___dmlwRV",
};

module.exports = exports;
